import { createFileRoute } from '@tanstack/react-router'
import { JobOverview } from '@/features/job-detail/overview'

export const Route = createFileRoute('/_authenticated/jobs/$jobId/')({
  component: JobOverview,
})
